import React, { useEffect, useState } from "react";
import { Plane } from "lucide-react";
import { cn } from "@/lib/utils";

interface ProgramLogoProps {
  src?: string;
  /** Size override, e.g. "h-5 w-5". Defaults to the 11x11 avatar size. */
  className?: string;
}

export const ProgramLogo: React.FC<ProgramLogoProps> = ({
  src,
  className,
}) => {
  // Logos are vendor-hosted URLs we don't control, so a dead link has to fall
  // back to the icon instead of leaving a broken image in the dropdown.
  const [failed, setFailed] = useState(false);

  useEffect(() => setFailed(false), [src]);

  return (
    <span
      className={cn(
        "flex h-11 w-11 shrink-0 items-center justify-center overflow-hidden rounded-full bg-sky-50 dark:bg-sky-900/30",
        className
      )}
    >
      {src && !failed ? (
        <img
          src={src}
          alt=""
          onError={() => setFailed(true)}
          className="h-full w-full object-cover"
        />
      ) : (
        <Plane className="h-full w-full p-1 text-sky-500 dark:text-sky-400" />
      )}
    </span>
  );
};
